import plan3d from "./plan-3d.jpg";
import plan2d from "./plan-2d.jpg";

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

export const hradecKraloveGocarovaBytImages: string[] = Object.entries(photoModules)
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const hradecKraloveGocarovaBytFloorPlans: { image: string; label: string }[] = [
  { image: plan3d, label: "Půdorys – 3D" },
  { image: plan2d, label: "Půdorys – 2D" },
];
